const e = {
  xs: 640,
  // @media (max-width: 640x) { ... }
  sm: 1024,
  md: 1280,
  lg: 1464,
  xl: 1500
}, a = (m) => {
  const t = {};
  return typeof m == "string" ? m.split(/[\s,]+/).filter((i) => i).forEach((i) => {
    const d = i.split(":");
    if (d.length !== 2)
      return;
    const s = d[0].trim(), n = d[1].trim();
    s && n && (t[s] = n);
  }) : Object.assign(t, m), t;
}, l = (m, t) => {
  const i = a(m);
  return [
    {
      src: t.xs,
      name: "xs",
      minWidth: 0,
      defaultWidth: e.xs,
      imageWidth: i.xs
    },
    {
      src: t.sm,
      name: "sm",
      minWidth: e.xs,
      defaultWidth: e.sm,
      imageWidth: i.sm
    },
    {
      src: t.md,
      name: "md",
      minWidth: e.sm,
      defaultWidth: e.md,
      imageWidth: i.md
    },
    {
      src: t.lg,
      name: "lg",
      minWidth: e.md,
      defaultWidth: e.lg,
      imageWidth: i.lg
    },
    {
      src: t.xl,
      name: "xl",
      minWidth: e.lg,
      defaultWidth: e.xl,
      imageWidth: i.xl
    }
  ];
};
export {
  l as getImageBreakpoints,
  a as getImageSizes,
  e as imageScreenSizes
};
